import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Button list',
  name: 'buttonList',
  type: 'object',
  fields: [
    defineField({
      name: 'align',
      title: 'Align',
      type: 'string',
      options: {
        list: [
          { title: 'Left', value: 'LEFT' },
          { title: 'Center', value: 'CENTER' },
          { title: 'Right', value: 'RIGHT' },
        ],
        layout: 'radio',
      },
      initialValue: 'CENTER',
    }),
    defineField({
      name: 'buttons',
      title: 'Buttons',
      type: 'array',
      of: [
        {
          name: 'button',
          type: 'object',
          fields: [
            defineField({
              title: 'Link',
              name: 'link',
              type: 'link',
            }),
            defineField({
              name: 'theme',
              title: 'Theme',
              type: 'string',
              options: {
                list: [
                  // Note: these will be converted to brand/alpha/beta in buttonListComponent.groq
                  { title: 'Red', value: 'BLUE' },
                  { title: 'White', value: 'WHITE' },
                  { title: 'Black', value: 'BLACK' },
                ],
                layout: 'radio',
              },
              initialValue: 'BLUE',
            }),
            defineField({
              name: 'rounded',
              title: 'Border rounding',
              type: 'boolean',
              initialValue: false,
              description:
                'Controls the button border rounding (square vs rounded)',
            }),
          ],
          preview: {
            select: {
              title: 'link.title',
              internalTitle: 'link.url_internal.pageInfo.title',
              externalUrl: 'url_external',
              customUrl: 'url_custom',
            },
            prepare({ title, internalTitle, externalUrl, customUrl }) {
              return {
                title: title || internalTitle || externalUrl || customUrl || 'Button',
                subtitle: 'Button',
              }
            },
          },
        },
      ],
    }),
  ],
  preview: {
    select: {
      align: 'align',
      buttons: 'buttons',
    },
    prepare({ align, buttons }) {
      const count = buttons?.length || 0
      return {
        title: `${count} buttons, aligned ${align?.toLowerCase() || 'center'}`,
        subtitle: 'Button list',
      }
    },
  },
})
